import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";

const firebaseConfig = {
  apiKey: "AIzaSyBrYUwW3CvjFGNXK4cm3iLlurmJoXH-7qE",
  authDomain: "endocrinologistaagora-218d9.firebaseapp.com",
  projectId: "endocrinologistaagora-218d9",
  storageBucket: "endocrinologistaagora-218d9.firebasestorage.app",
  messagingSenderId: "120222843719",
  appId: "1:120222843719:web:cdf887659dc95632780262",
  measurementId: "G-7XTR1NJ5R7"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const db = getFirestore(app);
const storage = getStorage(app);

export { db, storage };
